module.exports = __webpack_public_path__ + "static/media/addon-ga.589ccdf6.png";